import { useMemo, useState } from "react";
import {
  generateSubscriberData,
  getPlanDistribution,
  groupAnalyticsData,
  summarizeAnalyticsData,
} from "../analyticsData";

const DEFAULT_FILTERS = {
  regionType: "All",
  plan: "All",
  status: "All",
  groupBy: "month",
  startDate: "2023-01-01",
  endDate: "2024-12-31",
};

export function useSubscriptionAnalytics() {
  const [data] = useState(generateSubscriberData);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const processedData = useMemo(() => groupAnalyticsData(data, filters), [data, filters]);
  const summaryMetrics = useMemo(() => summarizeAnalyticsData(data, filters), [data, filters]);
  const planData = useMemo(() => getPlanDistribution(data, filters), [data, filters]);

  const uniquePlans = useMemo(() => [...new Set(data.map((item) => item.plan))], [data]);
  const uniqueStatuses = useMemo(() => [...new Set(data.map((item) => item.status))], [data]);

  const handleFilterChange = (filterType, value) => {
    setIsLoading(true);
    setFilters((prev) => ({ ...prev, [filterType]: value }));
    window.setTimeout(() => setIsLoading(false), 300);
  };

  const resetFilters = () => {
    setIsLoading(true);
    setFilters(DEFAULT_FILTERS);
    window.setTimeout(() => setIsLoading(false), 300);
  };

  return {
    filters,
    isLoading,
    processedData,
    summaryMetrics,
    planData,
    uniquePlans,
    uniqueStatuses,
    handleFilterChange,
    resetFilters,
  };
}
